export const ALERT = {
  ADD: 'ALERT_ADD',
  DISMISS_LAST: 'ALERT_DISMISS_LAST',
  DISMISS_BY_ID: 'ALERT_DISMISS_BY_ID',
  DISMISS_BY_TYPE: 'ALERT_DISMISS_BY_TYPE',
  DISMISS_BY_CUSTOM_TYPE: 'ALERT_DISMISS_BY_CUSTOM_TYPE',
  DISMISS_ALL: 'ALERT_DISMISS_ALL',
};

export const ALERT_TYPES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
};
